import { useIntl } from 'react-intl'

import CollectionTimeSVG from 'app/assets/icons/listing/collection-time.svg'
import Stack from 'app/components/base/Stack/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import {
  transformCollectionTime,
  transformCollectionDays
} from '../helpers/listing.helpers'

interface CollectionTimeProps {
  collectionTimeFrames: TimeFrameModel[]
}

const CollectionTime: RFC<CollectionTimeProps> = ({ collectionTimeFrames }) => {
  const { formatMessage } = useIntl()

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ alignItems: 'flex-start', mt: IS_NATIVE_APP ? 2 : 0 }}
    >
      <CollectionTimeSVG />

      <Stack direction="column" spacing={1}>
        <Text variant="body2">
          {formatMessage({ defaultMessage: 'Collection Time:' })}
        </Text>

        {collectionTimeFrames.map((item) => {
          const collectionDays = transformCollectionDays(
            item.days,
            formatMessage
          )
          const collectionTime = transformCollectionTime(
            item.from_time,
            item.to_time
          )

          return (
            <Stack key={item.id} direction="column">
              <Text variant="body2">{collectionDays}:</Text>

              <Text variant="body2" sx={{ color: 'text.third' }}>
                {collectionTime}
              </Text>
            </Stack>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default CollectionTime
